import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";
import { BlogList } from "@/components/BlogList";
import { blogPostsQueryOptions } from "@/lib/public-content.queries";

export const Route = createFileRoute("/blog/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(blogPostsQueryOptions),
  errorComponent: () => (
    <Layout>
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 section-y-hero text-center">
        <h1 className="heading-h1">Beiträge konnten nicht geladen werden.</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Bitte versuchen Sie es später erneut.
        </p>
      </div>
    </Layout>
  ),
  notFoundComponent: () => (
    <Layout>
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 section-y-hero text-center">
        <h1 className="heading-h1">Keine Beiträge gefunden.</h1>
      </div>
    </Layout>
  ),
  head: () => ({
    meta: [
      { title: "Blog – creategy" },
      {
        name: "description",
        content:
          "Analysen, Essays und Werkstattberichte zur politischen Kommunikation. Strategie, Kampagnen, Diskurs.",
      },
      { property: "og:title", content: "Blog – creategy" },
      {
        property: "og:description",
        content: "Analysen und Essays zur politischen Kommunikation.",
      },
      { property: "og:url", content: "https://creategy.de/blog" },
    ],
    links: [{ rel: "canonical", href: "https://creategy.de/blog" }],
  }),
  component: BlogIndex,
});

function BlogIndex() {
  return (
    <Layout>
      <section>
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 section-y-hero">
          <h1 className="heading-h1 max-w-3xl">
            Gedanken aus der politischen Werkstatt.
          </h1>
          <p className="fade-in-up mt-6 max-w-2xl text-base text-muted-foreground md:text-lg" style={{ animationDelay: "120ms" }}>
            Analysen, Essays und Werkstattberichte zur politischen Kommunikation.
          </p>
        </div>
      </section>


      <section>
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 section-y">
          <BlogList />
        </div>
      </section>
    </Layout>
  );
}
